import React, { useEffect, useState, useCallback } from "react";
import "../styles/DashboardAdmin.css";
import { API_BASE } from "../config";

export const RendezVousAdmin = ({ user }) => {

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [status, setStatus] = useState("");
  const [date, setDate] = useState("");
  const [search, setSearch] = useState("");

  const limit = 10;
  const [toast, setToast] = useState({ type: "", msg: "" });

  const showToast = (type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast({ type: "", msg: "" }), 3200);
  };
  const formatDateParis = (iso) => {
    if (!iso) return "—";
  
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
  
    return d.toLocaleString("fr-FR", {
      timeZone: "Europe/Paris",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const fetchRdv = useCallback(async () => {

    setLoading(true);
    setError("");

    try {

      const params = new URLSearchParams();

      params.set("page", page);
      params.set("limit", limit);

      if (status) params.set("status", status);
      if (date) params.set("date", date);
      if (search) params.set("q", search);

      const res = await fetch(
        `${API_BASE}/admin/rendezvous?${params}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.msg || "Erreur chargement RDV");
      } else {
        setItems(data.items || []);
        setTotal(data.total || 0);
      }

    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }

  }, [page, status, date, search, user.token]);


  useEffect(() => {
    fetchRdv();
  }, [fetchRdv]);


  const pages = Math.max(1, Math.ceil(total / limit));


  const handleRefresh = async () => {
    setPage(1);
    await fetchRdv();
    showToast("success", "Liste des rendez-vous mise à jour");
  };


  return (

    <div className="adminPanel">

      {/* HEADER */}

      <div className="adminPanelHeader">

        <div>
          <div className="adminPanelTitle">
          </div>

          <div className="adminPanelSub">
          </div>
        </div>

        <button
          className="btnSecondary"
          onClick={handleRefresh}
          disabled={loading}
        >
          {loading ? "Chargement..." : "Rafraîchir"}
        </button>

      </div>


      {/* TOOLBAR */}

      <div className="adminToolbar">

        {/* RECHERCHE */}

        <input
          className="adminInput"
          placeholder="Rechercher patient, médecin, collectivité..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setPage(1);
              fetchRdv();
            }
          }}
        />


        {/* FILTRE STATUT */}

        <select
          className="adminSelect"
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setPage(1);
          }}
        >

          <option value="">Tous les statuts</option>
          <option value="CONFIRME">Confirmé</option>
          <option value="ANNULE">Annulé</option>
          <option value="EN_ATTENTE">En attente</option>

        </select>


        {/* FILTRE DATE */}

        <input
          type="date"
          className="adminInput"
          value={date}
          onChange={(e) => {
            setDate(e.target.value);
            setPage(1);
          }}
        />


        {/* BOUTON RECHERCHE */}

        <button
          className="btnPrimary"
          onClick={() => {
            setPage(1);
            fetchRdv();
          }}
        >
          Rechercher
        </button>

      </div>


      {error && (
        <div className="adminError">
          {error}
        </div>
      )}
          {toast.msg && (
      <div className={`adminToast ${toast.type}`}>
        {toast.msg}
      </div>
    )}


      {/* TABLE */}

      <div className="adminTableWrap">

        <table className="adminTable">

          <thead>
            <tr>
              <th>Date</th>
              <th>Médecin</th>
              <th>Collectivité</th>
              <th>Patient</th>
              <th>Statut</th>
            </tr>
          </thead>

          <tbody>

            {loading && (
              <tr>
                <td colSpan={5} className="adminEmpty">
                  Chargement...
                </td>
              </tr>
            )}

            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={5} className="adminEmpty">
                  Aucun rendez-vous trouvé.
                </td>
              </tr>
            )}

            {!loading && items.map((r) => (

              <tr key={r.id}>

                <td style={{ fontSize: "12px" }}>{formatDateParis(r.date)}</td>

                <td style={{ fontSize: "12px" }}>{r.medecin}</td>

                <td style={{ fontSize: "12px" }}>{r.collectivite}</td>

                <td style={{ fontSize: "12px", fontWeight: 500 }}>
                  {r.patient}
                </td>

                <td>
                  <span className={`statusBadge ${r.status.toLowerCase()}`}>
                    {r.status}
                  </span>
                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>


      {/* PAGINATION */}

      <div className="adminPager">

        <button
          className="btnSecondary"
          onClick={() =>
            setPage((p) => Math.max(1, p - 1))
          }
          disabled={page === 1}
        >
          ←
        </button>

        <div className="adminPagerInfo">
          Page <b>{page}</b> / {pages} — Total: <b>{total}</b>
        </div>

        <button
          className="btnSecondary"
          onClick={() =>
            setPage((p) => Math.min(pages, p + 1))
          }
          disabled={page >= pages}
        >
          →
        </button>

      </div>

    </div>

  );
};